import {
  FrontendError,
  FrontendErrorCodesCms,
  MAX_LESSON_DURATION_MINUTES,
  MAX_LESSON_DURATION_SECONDS,
  getFrontendErrorMessageFromCode,
} from "@repo/common";

/**
 * CMS audio duration is `HTMLAudioElement.duration` (seconds). Compare against
 * the 240-minute cap in seconds so lessons longer than four minutes are allowed.
 */
export const assertLessonDurationWithinCap = (durationSeconds: number): void => {
  if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) {
    throw new FrontendError(
      getFrontendErrorMessageFromCode(FrontendErrorCodesCms.LessonDurationInvalid),
      FrontendErrorCodesCms.LessonDurationInvalid,
      "warning",
    );
  }

  if (durationSeconds > MAX_LESSON_DURATION_SECONDS) {
    throw new FrontendError(
      `Audio ist zu lang. Maximal erlaubt: ${String(MAX_LESSON_DURATION_MINUTES)} Minuten. Bitte kürzen und erneut hochladen.`,
      FrontendErrorCodesCms.LessonDurationExceedsCap,
      "warning",
    );
  }
};
